import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

const Box = ({ value, unit, text, icon, color, textsize = "14px" }) => {
  const [styles, setStyles] = useState({});

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth < 640) {
        setStyles({
          borderLeftWidth: "12px",
          borderLeftColor: color,
        });
      } else if (screenWidth >= 640 && screenWidth < 1024) {
        setStyles({
          borderLeftWidth: "2px",
          borderBottomWidth: "12px",
          borderLeftColor: "#d6d6d6",
          borderBottomColor: color,
        });
      } else {
        setStyles({
          borderLeftWidth: "12px",
          borderBottomWidth: "2px",
          borderLeftColor: color,
          borderBottomColor: "#d6d6d6",
        });
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [color]);

  // Determine the unit to display
  const getDisplayUnit = () => {
    if (unit) return unit;
    if (text?.toLowerCase().includes("percentage") && !value?.includes("%"))
      return "%";
    if (text?.toLowerCase().includes("in meters")) return "m";

    return "";
  };

  const displayUnit = getDisplayUnit();

  return (
    <div
      className={`grid grid-cols-5 sm:grid-cols-1 md:grid-cols-5 p-3 lg:p-4 gap-3 md:gap-1 
        border border-[#d6d6d6] w-full items-center`}
      style={styles}
    >
      <div className="text-start sm:text-center col-span-4 sm:col-span-1 md:col-span-4 md:text-start sm:order-last md:order-first ">
        <div className=" ">

          {icon ? (
        <FontAwesomeIcon icon={icon} className="mx-auto " />
      ) : (
        
        <FontAwesomeIcon icon={faCircleQuestion} className="mx-auto opacity-50" />
      )}

      
        </div>
        <p
          style={{ "fontSize": textsize }}
          className={`w-[95%] text-gray-600 `}
        >
          {text}
        </p>
      </div>
      <div className="flex flex-nowrap items-center justify-center gap-2">
        <svg height="90" width="2" className="sm:hidden md:block shrink-0">
          <line x1="1" y1="0" x2="1" y2="90" stroke="#d6d6d6" strokeWidth="3" />
        </svg>
        <div className=" sm:flex flex-nowrap justify-center items-center w-full ">
          <span className="text-2xl font-bold " /* style={{ color: color }} */>
            {value?.split(" ").join("")}
          </span>
          <span className="text-lg font-semibold ml-1">{displayUnit}</span>
        </div>
      </div>
    </div>
  );
};

export default Box;
